import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-filter-users',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './mdl-filter-users.html',
  styleUrl: './mdl-filter-users.css' 
})
export class MdlFilterUsers {
  constructor(
    public mdl: MatDialogRef<MdlFilterUsers>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.filters = { ...this.filters, ...data };
    }
  }

  filters = {
    allRoles: true,
    allStatuses: true,
    lastLogin: 'all',
    roles: {
      administrador: false,
      ejecutivo: false,
      otros: false
    },
    statuses: {
      activo: false,
      inactivo: false
    }
  };

  roleTypes: Array<keyof typeof this.filters.roles> = [
    'administrador',
    'ejecutivo',
    'otros'
  ];

  statusTypes: Array<keyof typeof this.filters.statuses> = [
    'activo',
    'inactivo'
  ];

  toggleAllRoles() {
    if (this.filters.allRoles) {
      for (const key of this.roleTypes) {
        this.filters.roles[key] = true;
      }
    } else {
      for (const key of this.roleTypes) {
        this.filters.roles[key] = false;
      }
    }
  }

  onRoleChange() {
    const allRolesSelected = this.roleTypes.every(key => this.filters.roles[key]);
    const anyRoleSelected = this.roleTypes.some(key => this.filters.roles[key]);
    
    this.filters.allRoles = allRolesSelected;
    
    if (!anyRoleSelected) {
      this.filters.allRoles = true;
      this.toggleAllRoles();
    }
  }

  toggleAllStatuses() {
    if (this.filters.allStatuses) {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = true;
      }
    } else {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = false;
      }
    }
  }

  onStatusChange() {
    const allStatusesSelected = this.statusTypes.every(key => this.filters.statuses[key]);
    const anyStatusSelected = this.statusTypes.some(key => this.filters.statuses[key]);
    
    this.filters.allStatuses = allStatusesSelected;
    
    if (!anyStatusSelected) {
      this.filters.allStatuses = true;
      this.toggleAllStatuses();
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  applyFilters() {
    this.mdl.close(this.filters);
  }
}